import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { FormControl, Validators } from '@angular/forms';
import { SharedToolsService } from '@huge-monorepo/shared/tools';
import { TableHeader } from '@huge-monorepo/shared/interfaces';
import { ToolsModule } from '@huge-monorepo/shared/tools';

@Component({
  selector: 'huge-monorepo-teltonika-create-report-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule, ToolsModule],
  templateUrl: './TeltonikaCreateReportModal.component.html',
  styleUrl: './TeltonikaCreateReportModal.component.scss',
})
export class TeltonikaCreateReportModalComponent {
  public devices: any[] = [];
  startDateControl = new FormControl(this.tools.GetStartOfMonth(new Date()), Validators.required);
  endDateControl = new FormControl(new Date(), Validators.required);
  allSelected: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<TeltonikaCreateReportModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private tools: SharedToolsService,
  ) {
    this.allSelected = data.allSelected;
    this.devices = data.devices;
  }


  headers: TableHeader[] = [
    {
      ID: 'id',
      Index: 0,
      Sort: 'id',
      Sortable: false,
      Text: 'ID',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'TeltonikaCustomName',
      Index: 1,
      Sort: 'TeltonikaCustomName',
      Sortable: false,
      Text: 'Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'name',
      Index: 2,
      Sort: 'name',
      Sortable: false,
      Text: 'Serial',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'MACAddress',
      Index: 3,
      Sort: 'MACAddress',
      Sortable: false,
      Text: 'MAC',
      Type: String,
      Align: 'left',
    },
  ];

  close(success: boolean) {
    if (this.startDateControl.invalid || this.endDateControl.invalid) {
      this.startDateControl.markAsTouched();
      this.endDateControl.markAsTouched();
      return
    }
    const deviceIDs = this.devices.map(d => d.id);
    this.dialogRef.close(success ? { DeviceIDs: deviceIDs, Start: this.startDateControl.value, End: this.endDateControl.value } : null);
  }
}
